import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "sonner";

import AnnouncementBar from "@/components/layout/AnnouncementBar";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import MobileBottomNav from "@/components/layout/MobileBottomNav";
import CartDrawer from "@/components/layout/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Wishlist from "@/pages/Wishlist";
import SearchPage from "@/pages/SearchPage";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Account from "@/pages/Account";
import AskExpert from "@/pages/AskExpert";
import { About, Contact } from "@/pages/AboutContact";
import Policies from "@/pages/Policies";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { Builds, BuildDetail, BuildEnquiry } from "@/pages/Builds";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function Layout({ children }) {
  const loc = useLocation();
  const isAdmin = loc.pathname.startsWith("/admin");
  if (isAdmin) return children;
  return (
    <>
      <AnnouncementBar />
      <Header />
      <main className="pb-safe-nav min-h-[60vh]">{children}</main>
      <Footer />
      <MobileBottomNav />
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppProvider>
          <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#111", color: "#fff", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 0 } }} />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/collection/:slug" element={<Shop />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:id" element={<OrderSuccess />} />
              <Route path="/account" element={<Account />} />
              <Route path="/ask-expert" element={<AskExpert />} />
              <Route path="/builds" element={<Builds />} />
              <Route path="/builds/:id" element={<BuildDetail />} />
              <Route path="/build" element={<BuildEnquiry />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/policies/:kind" element={<Policies />} />
              <Route path="/admin/*" element={<AdminDashboard />} />
            </Routes>
          </Layout>
        </AppProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
